export default "__VITE_ASSET__4uXDJ6Hc__"